const spa = {
  aboutMe: "Para mas info sobre el mi.",
  profile: "Perfil",
  hiAdmin: "Hola Admin",
  username: "Usuario",
  password: "contraseña",
  login: "ingresar",
  loginCap: "Ingresar",
  signup: "registrarse",
  signupCap: "Registrarse",
  pricesCap: "Precios",
  loginTitle: "Inicia tu sesión",
  signupTitle: "¡Regístrate y empieza a bailar!",
  email: "Correo electrónico",
  contactUs: "Contacto",
  privacyPolicy: "Políticas de privacidad",
  termsOfUse: "Términos de uso",
  copyright: "Todos los derechos reservados © 2017-2021 Bailo.app",
  followUs: "Síguenos en: fb, twitter, instagram",
  following: "Siguiendo",
  iLike: "me gusta",
  aboutUs: "Sobre nosotros",
  faq: "Preguntas frecuentes",
  downloadApp: "Descarga la APP",
  withLove: "Hecho con ❤️ en Barcelona",
  homepage: "inicio",
  map: "Mapa",
  myBailo: "Lead",
  lead: "Gestionar",
  logout: "salir",
  titleMapdot: "título",
  ownerMapdot: "organizador",
  addMapdot: "Añadir Bailo Dot",
  myBailoDotsFollow: "Bailo Dots que sigo",
  myBailoDotsLead: "Eventos que gestiono",
  noVenuesILead: "Todavía no tenés ningún evento para gestionar.",
  myAdsLead: "Gestión de anuncios",
  myMeetups: "Reuniones a las que voy",
  dance: "baile",
  category: "categoría",
  title: "título",
  description: "descripción",
  address: "dirección",
  addressPlus: "info adicional",
  postalCode: "código postal",
  city: "ciudad",
  country: "país",
  countryNotFound: "No se encontró el país",
  searchCountry: "Buscar país",
  cityNotFound: "No se encontró la ciudad",
  phoneNr: "teléfono",
  emailMapdot: "correo electrónico profesional",
  website: "página web",
  instagram: "Instagram",
  facebook: "Facebook",
  checkAddress: "Verificar dirección",
  dayOfTheWeek: "día de la semana",
  sectionBasicData: "Datos Básicos",
  sectionLocation: "Ubicación",
  sectionSchedule: "Horarios",
  day: "día",
  frequency: "frecuencia",
  dateStart: "fecha - inicio",
  dateEnd: "fecha - fin",
  timeStart: "hora - inicio",
  timeEnd: "hora - fin",
  price: "precio",
  typeOf: "tipo",
  buttonAdd: "Añadir",
  venue: "milonga",
  practica: "práctica",
  tango: "tango",
  monday: "lunes",
  tuesday: "martes",
  wednesday: "miércoles",
  thursday: "jueves",
  friday: "viernes",
  saturday: "sábado",
  sunday: "domingo",
  once: "única vez",
  weekly: "semanal",
  fortnightly: "quincenal",
  monthly: "mensual",
  editMapdot: "editar",
  reviewIt: "Revisar",
  editBailoDot: "Editar Bailo Dot",
  buttonUpdate: "actualizar",
  buttonDelete: "borrar",
  followLink: "siguir bailo-dots",
  leadLink: "llevar bailo-dots",
  addLink: "añadir bailo-dots",
  filterBy: "Filtrar por ciudad",
  filterByMilongaName: "Buscar por nombre",
  search: "Buscar",
  filter: "Filtro",
  admin: "Admin",
  adminAllBailoDots: "bailo-dots",
  adminPendingBailoDots: "bailo-dots pendientes",
  adminUsers: "Usuarios",
  customerChat: "Chat con usuarios",
  danceRole: "rol en el baile",
  statusUser: "estado del usuario",
  all: "todos",
  approved: "aprobado",
  approve: "Aprobar",
  reject: "Rechazar",
  rejected: "rechazado",
  onhold: "en espera",
  pending: "pendiente",
  userProfile: "perfil de usuario",
  numberOfLikes: "seguidores",
  activeSince: "activo desde",
  musicStyle: "estilo de música",
  additionalInfo: "información adicional",
  statusMapdot: "estado",
  imageMapdot: "imagen",
  yes: "sí",
  no: "no",
  realOwner: "¿Es tu Bailo Dot?",
  useReverseGeo: "usa mi ubicación",
  locationAnswer: "ubicación del bailo-dot guardado",
  userLocation: "Ubicación",
  createdBy: "creado por",
  latitude: "latitud",
  longitude: "longitud",
  stars: "estrellas",
  note: "nota",
  date: "fecha",
  meetups: "Reunión de eventos",
  addMeetUp: "añadir una reunión",
  createdMeetups: "reunión creada",
  attendMeetups: "asistir a una reunión",
  editMeetUp: "editar reunión",
  userAbout: "Sobre mi",
  userAboutMe: "Sobre mi",
  personalInformation: "Información Personal",
  unfriend: "Eliminar amistad",
  friends: "Amigos",
  block: "Bloquear",
  unblock: "Desbloquear",
  cancelFriendship: "Cancelar solicitud",
  acceptFriendship: "Acceptar solicitud",
  denyFriendship: "Rechazar solicitud",
  social: "Social",
  shortInfo: "Info",
  reviews: "Reseñas",
  noReviews: "Aún sin comentarios",
  addReview: "Añandir reseña",
  goGoogle: "Como llegar allí",
  capacity: "Aforo disponible",
  booking: "Reservar",
  dateOfMeeting: "fecha de la reunión",
  hasComments: "comentarios",
  participants: "Participantes",
  editProfile: "Editar perfil",
  danceRoleLeader: "líder",
  danceRoleFollower: "seguidor/a",
  danceRoleBoth: "ambos",
  new: "Nuevo",
  repeat: "Repetir",
  settings: "Ajustes",
  editPassword: "Editar contraseña",
  landingTitle: "No vuelvas a preguntar dónde bailar esta noche",
  subTitleOne: "Encuentra milongas, festivales, prácticas, clases, conciertos y música en vivo en todo el mundo.",
  subTitleTwo: "espacios y eventos de tango publicados en +30 países",
  seeMilongasNearMe: "Ver milongas cerca mío",
  hideMilongasMap: "Ocultar mapa",
  downloadAppBtn: "Descargar app",
  statMilongasMapped: "+1.000 milongas en el mapa",
  statCountries: "+30 países",
  statLanguages: "ES EN RU DE",
  organizerCtaTitle: "¿Organizas eventos de tango?",
  organizerCtaSubtitle: "Tu milonga puede estar ya en Bailo.app. Publicala gratis, actualizala cuando quieras y mirá las estadísticas en tiempo real.",
  organizerCtaCheck1: "Llegá a bailarines que buscan en tu ciudad",
  organizerCtaCheck2: "Mirá estadísticas en tiempo real: visitas, likes, clics de contacto",
  organizerCtaCheck3: "Actualizá tu info cuando quieras, sin esperas",
  organizerCtaButton: "Publicar mi milonga — gratis",
  organizerCtaNote: "Gratis. Sin compromiso. Acceso por enlace.",
  labelForDancers: "Para bailarines",
  labelForOrganizers: "Para organizadores",
  howItWorksLabel: "cómo funciona",
  howItWorksSearch: "Buscar",
  howItWorksSearchText: "Tu ciudad o usá tu ubicación",
  howItWorksFilter: "Filtrar",
  howItWorksFilterText: "Día, horario, tipo de evento",
  howItWorksGoDance: "A bailar",
  howItWorksGoDanceText: "Guardá favoritos, recibí notificaciones",
  subTitleThree: "Puedes registrar tu propia milonga.",
  subTitleFour:
    "Navega, busca hospedaje y llega a tu destino final de forma sencilla.",
  landingFeatureOne: "Siempre nuevas funcionalidades",
  landingFeatureTwo: "Comunidad tanguera en crecimiento",
  landingFeatureThree: "Fácil de usar & gratis",
  landingFeatureOneText:
    "La mejora contínua es importante para nosotros y agradecemos tus comentarios.",
  landingFeatureTwoText:
    "¿Falta una milonga en el mapa? ¡Agrégala o avísanos y lo hacemos por vos!",
  landingFeatureThreeText:
    "Crea o encuentra tu milonga rápidamente, sea desde casa o durante tus viajes.",
  landingStory: "Nuestra historia",
  landingStoryTextOne:
    "Nuestro propósito es crear una comunidad internacional de tango con milongas fáciles de encontrar en todo el mundo.",
  landingStoryTextTwo:
    "Bailo.app nació en 2017 bajo el nombre de Tango Maps como un simple mapa con nuestras milongas favoritas, principalmente en Barcelona, Nueva Zelanda, Israel, Italia y Córdoba, Argentina. Ambos somos amantes del tango y (qué sorpresa) nos conocimos bailando tango en Barcelona.",
  landingStoryTextThree:
    "Hasta hoy, hemos recibido comentarios positivos de amantes del tango de todo el mundo a quienes les gusta viajar, conocer a otros tangueras y tangueros y disfrutar de algunos bailes de tango. Bailo.app es más que una simple lista de lugares de tango, Bailo.app es una comunidad online en crecimiento.",
  landingStoryTextFour:
    "Bailo.app disfruta del tango con sus tradiciones y también apoya nuevos movimientos, como la música de tango alternativo y el intercambio de roles de género/baile.",
  landingMarceOne: "Amante del tango desde 2012",
  landingMarceTwo: "De Argentina",
  landingMarceThree: "Analista de Sistemas & Desarrollador Web",
  landingTashOne: "Amante del tango desde febrero 2006",
  landingTashTwo: "De Alemania",
  landingTashThree: "Lingüista & Web Developer",
  typeLetter: "escribe una letra",
  noResultsfound: "no hay resultados",
  contactUsText:
    "¿Tienes algunas preguntas o comentarios? Contáctanos: bailo.app@gmail.com",
  bailoDots: "Bailo Dots",
  follow: "Siguiendo",
  leadBailoDots: "Gestión de eventos",
  leadMeetups: "Gestión de reuniones",
  addBailoDot: "Crear",
  addMeetup: "Añadir Reunión",
  haveAnAccount: "Ya estas registrado?",
  keenTo: "Le gustaría",
  backTo: "Regregar al",
  class: "clase",
  school: "escuela",
  teacher: "profesor/a",
  acceptTUPPOne: "Yo acepto los",
  acceptTUPPTwo: "y",
  help: "Ayuda",
  commonQuestions: "Preguntas frecuentes",
  bailoYouTube: "Tango Cortometrajes",
  bailoYouTubeText:
    "En búsqueda de los mejores cortometrajes que hablan del tango. Los derechos de cada video se mantiene con la persona que subió el video. Bailo.app simplemente quiere promover el mundo del tango.",
  bailoBlog: "Bailo.app Blog",
  bailoBlogText: "¡Mira nuestro último post en el Blog!",
  bailoBlogHomepageTitle: "Página principal del Blog",
  commonQuestionsTextLanding:
    "¿Cómo añado una milonga al mapa? ¿Qué es un Bailo Dot? Esta pregunta y otras serán respondidas en nuestra sección de preguntas frecuentes. Por si hay otras dudas, avísanos vía mail",
  comments: "Comentarios",
  addComment: "Añadir comentario",
  userCommentUpdate: "¿Quieres actualizar tu comentario?",
  comment: "comentario",
  finalDot: ".",
  analytics: "Analytics",
  notionLink: "Notion",
  siteAnalytics: "Analytics del Sitio",
  sendPush: "Enviar Push",
  allSentPush: "Historico Push",
  sureSendPush: "¿Estás seguro que quieres enviar este push?",
  sureApproveIt: "¿Estás seguro de que lo quieres aprobar?",
  updateComment: "Editar tu comentario",
  cancelButton: "cancelar",
  deleteComment: "Borrar tu comentario",
  cancel: "cancelar",
  spotsLeft: "plazas restantes",
  thankYou: "¡Muchas gracias",
  subscription: "Donación mensual en €",
  aLaGorra: "A la gorra",
  order: "Donación única",
  amount: "valor",
  bailoSupport: "Apoya a Bailo.app con tu contribución",
  donationTable: "Tabla de donaciones",
  yearlyDonation: "Donación anual",
  planSupport: "Apoyanos con lo que te nazca",
  from: "desde",
  plan1: "1€ mensualmente - La Yumba",
  plan2: "2€ mensualmente - Libertango",
  plan3: "5€ mensualmente - Farol",
  plan4: "10€ mensualmente - Poema",
  plan5: "15€ mensualmente - La cumparsita",
  planCli1: "La Yumba",
  planCli2: "Naranjo en flor",
  planCli3: "La cumparsita",
  paymentTitle: "Tu donación ayuda a mantener el proyecto vivo. ¡Gracias!",
  paymentTextOne: "Donación anual automática.",
  paymentTextTwo: "Podés cancelarla en cualquier momento.",
  paymentTextThree: "Esta donación será por única vez",
  paymentTextFour:
    "Serás redirigido a Buy Me a Coffee para confirmar tu donación.",
  paymentTextFive: "THANK YOU. GRACIAS. DANKE. MERCI.",
  donateBtn: "Donar vía Buy Me a Coffee",
  empty: "",
  saveChanges: "Guardar cambios",
  closeButton: "Cerrar",
  viewDetails: "Ver detalles",
  refNumber: "Tu número de referencia: ",
  deleteMyUser: "Quitar mi usuario",
  publicName: "nombre público",
  dateOnce: "fecha",
  termsOfClass: "términos de clase",
  classLevel: "nivel",
  offersOnlineLesson: "clases online",
  offersPrivateLesson: "clases privadas",
  sectionClassSchedule: "Horario de clases",
  addClassSlot: "Agregar clase",
  removeSlot: "Quitar",
  selectSchool: "Vincular con escuela",
  selectTeacher: "Vincular con profesor/a",
  classTeacherName: "Nombre del/la profesor/a",
  noClassSlots: "Aún no hay clases. Usá el botón para agregar una.",
  sectionTeacherSchedule: "Horario de enseñanza",
  addTeacherScheduleSlot: "Agregar horario",
  noTeacherScheduleSlots: "Aún no hay horarios. Usá el botón para agregar uno.",
  schoolName: "Escuela (buscá o escribí libremente)",
  infoAddBailoDot:
    "Ni bien te aceptemos el Bailo Dot, podrás interconectarlo con otros Bailo Dots.",
  addSchool: "Conecta con tu escuela",
  addNoSchool: "No vincular escuela / desvincular",
  noSchoolFound: "no hay escuelas",
  linkedSchool: "Escuela vinculada",
  noSchoolLinked: "sin escuela vinculada",
  addressAprox: "dirección aproximada",
  noDescriptionYet: "sin descripción aún",
  connections: "Conexiones con otros Bailo Dots",
  addTeacher: "Conecta con un/a profesor/a",
  addNoTeacher: "No vincular profesor/a / desvincular",
  noTeacherFound: "no hay profesores",
  linkedTeacher: "Profesor/a vinculado/a",
  noTeacherLinked: "sin profesor/a vinculado/a",
  share: "compartir",
  sureDelete: "¿Estás seguro que quieres borrar tu Bailo Dot?",
  leaveThisMeetup: "abandonar este Meetup",
  noNote: "sin nota",
  commentsGiven: "Comentarios dados",
  updateImg: "Subir imagen",
  dropImg: "Arrastra la imagen aquí",
  imgUpload: "imagen_subida",
  newMeetupCreated: "ha creado un nuevo evento para el",
  chatNotFound: "No se encontró el chat",
  registerWithAdminTash: "Ingresa con Admin Tash para responder al chat.",
  radio: "radio",
  musician: "artista",
  artist: "artista",
  artistType: "Tipo de artista",
  artistTypeHint:
    "Escribe qué tipo de artista eres. por ej: actor, actriz, cantante, músico",
  liveMusic: "música en vivo",
  festival: "festival",
  belongsToRadioStation: "estación de radio",
  belongsToPodcastPlatform: "platforma de podcast",
  languageSpokenRadio: "idioma que se habla",
  radioWebsite: "página web de la radio",
  linkWebsite: "enlace",
  buttonAddFriend: "Añadir a amigos",
  friendRequests: "Solucitudes de amistad",
  reportInfo: "Reportar un error o confirmar los datos",
  reportErrorDescription: "Descripción del error",
  addVenueInfo: "Agregar / actualizar info del evento",
  addVenueInfoLabel:
    "Agregá o actualizá detalles sobre este evento (ej: horarios, música, notas)",
  reportLastConfirmation: "Última confirmación",
  reportNoConfirmation: "Sin confirmación",
  confirmStatusGreen: "Info verificada recientemente",
  confirmStatusYellow: "Verificada hace más de 1 mes",
  confirmStatusRed: "Sin verificar",
  report: "Reportar",
  confirm: "Confirmar",
  edit: "Editar",
  reportsTitle: "Reportes",
  confirmTextOne: "Confirmado 🎉",
  confirmTextTwo: "Ahora podrás ingresar vía la app o la página web",
  confirmTextThree: "Descargar del Apple Store",
  confirmTextFour: "Descargar del Google Play",
  confirmTextFive: "Logguearse vía la página web",
  landingTryForFree: "Prueba gratis Bailo.app!",
  sending: "Enviando…",
  send: "Enviar",
  body: "body",
  googleSignup: "Registrarse con Google",
  googleLogin: "Ingresar con Google",
  facebookSignup: "Registrarse con Facebook",
  facebookLogin: "Ingresar con Facebook",
  dj: "dj",
  singer: "cantante",
  orchestra: "orquesta",
  bandoneonist: "bandoneonista",
  guitarist: "guitarrista",
  composer: "compositor",
  quartet: "cuarteto",
  band: "banda",
  musicianType: "músico - categoría",
  state: "provincia",
  county: "county",
  errorUsernameEmpty: "username es requerido",
  errorEmailEmpty: "email es requerido",
  errorEmailInvalid: "email inválido",
  errorPasswordInvalid: "password inválido",
  errorPasswordisLowercase: "agregar una minúscula",
  errorPasswordisUppercase: "agregar una Mayúscula",
  errorPasswordSpecialChars: "agregar caracter especial: #?!@$%^&*-",
  errorPasswordLength: "min 8 caracteres",
  errorPassword2Empty: "confirmar contraseña es requerido",
  errorPassword2Equals: "las contraseñas son distintas",
  errorUsernameExist: "Username ya existe",
  errorEmailExist: "Email ya existe",
  errorNotEmptyValues: "Campos no rellenados",
  passwordErrorInfo: "Información para contraseña",
  passwordInfo:
    "Contraseña: Por lo menos una letra en mayúscula (menos la ñ), por lo menos una letra en minúscula (menos la ñ), por lo menos un dígito, por lo menos un carácter especial (#?!@$%^&*-), longitud mínima: 8",
  ads: "Anuncios",
  clientAd: "Tu anuncio",
  addAd: "Añadir/Edit anuncio",
  leadAds: "Gestión de anuncios",
  here: "aquí",
  photoUpload: "Subir foto",
  adDescription: "dinos cómo quieres tu anuncio",
  selectOption: "Selecciona una opción",
  bePartOfProject: "cómo ser parte del proyecto",
  highlighted: "destacado",
  events: "eventos",
  paymentOptions: "opción de pago",
  bannerSize: "Tamaño del banner",
  bannerDesign: "Diseño de tu banner",
  bannerHighlight: "Banner destacado",
  linkToClientWeb: "Link a tu website",
  gifDesign: "Diseño de tu gif",
  facebookDisution: "Difusión por Facebook",
  InstagramDifusion: "Difusión por Instagram",
  notificacionesPush: "Notificaciones push",
  emailNotification: "Notificaciones por email",
  mapDotClient: "Marcador geográfico en mapa",
  mapdotDetailCli: "Información detallada de tu evento en Bailo.app",
  onMobileCli: "Tu info en la aplicación móvil",
  onWebCli: "Tu INFO la página web",
  goGoogleCli: "Cómo llegar a destino via google maps",
  anualPriceCli: "Precio (sin iva)",
  getPlan: "obtener plan",
  taxes: "IVA",
  list: "Lista",
  currentImg: "Imagen actual",
  download: "Descargar",
  successAdMessage: "Tu Anuncio fue agregado!",
  successEditAdMessage: "Tu Anuncio fue editado correctamente!",
  userRol: "Usuario",
  adminRol: "Admin",
  adsNotFound: "Todavía no tenés ningún anuncio.",
  adsLevel2Required: "Disponible a partir del Nivel 2",
  adsLevel3Required: "Disponible a partir del Nivel 3",
  userLevel: "Nivel",
  analyticsLevelRequired: "Analytics disponible a partir del Nivel 2",
  analyticsLevelRequiredDesc:
    "Sube de nivel para acceder a las estadísticas de tus milongas.",
  adsLevelRequired: "Anuncios disponibles a partir del Nivel 3",
  adsLevelRequiredDesc:
    "Sube de nivel para gestionar anuncios y promocionar tus milongas.",
  levelLabel: "Nivel",
  levelUp: "Subir nivel",
  levelDown: "Bajar nivel",
  confirmLevelUp: "Aumentar nivel para",
  confirmLevelDown: "Disminuir nivel para",
  levelUpdated: "¡Nivel actualizado!",
  levelUpdateFailed: "Error al actualizar el nivel",
  currentLevel: "Nivel actual",
  details: "Detalles",
  priceDescription:
    "Comience a utilizar la plataforma de Bailo.app hoy y descubre una nueva forma de promocionar tu producto o servicio de tango en el mundo.",
  whatsappContact:
    "¿Conoces una milonga que no esté aún en Bailo.app? ¡Escríbenos!",
  SendMessage: "Enviar mensaje",
  organizerCardTitle: "¿Organizas eventos de tango?",
  organizerCardSubtitle: 'Tu espacio puede estar ya publicado en Bailo.app. <strong style="color:#22c55e;font-size:15px;font-weight:700">Reclámalo gratis</strong>, mantelo actualizado y mirá cómo los bailarines interactúan con él.',
  organizerCardBullet1: "Gestiona y publica tus eventos",
  organizerCardBullet2: "Actualiza horarios y detalles",
  organizerCardBullet3: "Añade fotos, enlaces y ubicación",
  organizerCardBullet5: "Consulta estadísticas en tiempo real: visitas, búsquedas, likes y clics de contacto",
  organizerCardBullet6: "Llega a más bailarines cada día",
  manageMySpace: "Gestionar mi espacio",
  organizerCardFooter: "Gratis. Sin compromiso. Acceso por enlace.",
  cardPerk1: "Más visibilidad",
  cardPerk2: "Más bailarines",
  cardPerk3: "Analytics en tiempo real",
  cardPerk4: "Totalmente gratis",
  growYourSpaceTitle: "Haz crecer tu espacio",
  growYourSpaceText1: "Invita a tus alumnos y bailarines a descargar Bailo.app, buscar tu evento y darle like.",
  growYourSpaceText2: "Cuantos más likes e interacciones tenga tu evento, más fácil será medir el interés real.",
  loggedPerk1: "Más visibilidad en búsquedas",
  loggedPerk2: "Más likes = más interés",
  loggedPerk3: "Mejores estadísticas para vos",
  loggedPerk4: "100% gratis",
  downloadSectionTitle: "Lleva el tango siempre contigo",
  downloadSectionSubtitle: "Descarga la app y encuentra eventos cerca de ti, donde estés.",
  downloadFeature1: "Mapa en vivo de milongas cerca de ti",
  downloadFeature2: "Avisos cuando se acerca tu próxima favorita",
  downloadFeature3: "Funciona en cualquier ciudad del mundo, incluso de viaje",
  featureForDancers: "Para bailarines",
  featureForDancersText: "Encontrá los mejores eventos de tango cerca de vos en segundos. En cualquier parte del mundo.",
  featureForOrganizers: "Para organizadores",
  featureForOrganizersText: "Mantené tu info actualizada, consultá estadísticas en tiempo real y llegá a más bailarines cada día.",
  featureWorldwideCommunity: "Comunidad mundial",
  featureWorldwideCommunityText: "Una red en crecimiento de +1000 eventos y amantes del tango como vos.",
  requestAccess: "Solicitar acceso",
  requestAccessTitle: "Agrega o gestioná tu espacio de tango",
  requestAccessSubtitle: "Solo para organizadores. Si tu espacio ya está publicado en Bailo.app, podés reclamarlo. Si todavía no está, podés crearlo gratis.",
  requestAccessBullet1: "Actualizá eventos y horarios",
  requestAccessBullet2: "Mirá visitas, likes y búsquedas",
  requestAccessBullet3: "Acceso gratuito por enlace de acceso",
  requestAccessSent: "¡Solicitud enviada!",
  requestAccessSentDesc: "Hemos recibido tu solicitud. Si es aprobada, recibirás un enlace de acceso por correo en las próximas 24 horas.",
  businessType: "Tipo de negocio",
  emailAddress: "Correo electrónico",
  selectBusinessType: "¿Qué organizás?",
  businessTypeMilonga: "Milonga",
  businessTypeClass: "Clase de tango / escuela",
  businessTypeTeacher: "Profesor/a",
  businessTypeMusician: "Músico / orquesta",
  businessTypeFestival: "Festival / evento",
  businessTypeOther: "Otro",
  iAcceptThe: "Acepto los",
  and: "y",
  somethingWentWrong: "Algo salió mal. Por favor, intentá de nuevo.",
  checkFormAndTryAgain: "Por favor revisá el formulario e intentá de nuevo.",
  alreadyHaveAccount: "¿Ya tenés una cuenta?",
  goHome: "Inicio",
  accessRequests: "Solicitudes de acceso",
  resendMagicLink: "Reenviar enlace de acceso",
  confirmResendMagicLink:
    "Esto invalidará la contraseña actual y enviará un nuevo enlace de acceso al correo del usuario. ¿Estás seguro?",
  deleteUserForever: "Eliminar usuario permanentemente",
  confirmDeleteUser:
    "Esto eliminará permanentemente al usuario y todos sus datos. Sus eventos pasarán a estado En espera. Esta acción no se puede deshacer. ¿Estás seguro?",
  userVenues: "Eventos del usuario",
  adminUserDetail: "Detalle de usuario",
  usernameMaxChars: "Máximo 10 caracteres",
  addressOptional: "Dirección (opcional)",
  dangerZone: "Zona de peligro",
  confirmDeleteMyAccount:
    "Esto eliminará permanentemente tu cuenta y dejará todos tus eventos en estado En espera. Esta acción no se puede deshacer. ¿Estás seguro?",
  profileUpdated: "¡Perfil actualizado correctamente!",
  changeAvatar: "Cambiar avatar",
  chooseAvatar: "Elegir avatar",
  savingLabel: "Guardando…",
  noVenues: "Sin eventos",
  noVenuesListTitle: "¡Nada por aquí aún! 🕺",
  noVenuesListMsg:
    "No hay eventos para este día y filtro. ¡Probá otro día o categoría!",
  confirmedHeader: "confirmado",
  roleHeader: "rol",
  makeAdmin: "Hacer admin",
  removeAdmin: "Quitar admin",
  confirmMakeAdmin: "Otorgar permisos de admin a",
  confirmRemoveAdmin: "Quitar permisos de admin a",
  roleUpdatedSuccess: "Rol actualizado correctamente",
  roleUpdateFailed: "Error al actualizar el rol",
  searchUsersPlaceholder: "Buscar por usuario o país…",
  noUsersFound: "Sin usuarios",
  fetchingLabel: "Cargando...",
  resultsFound: "resultados encontrados",
  usersLabel: "usuarios",
  passwordUpdated: "¡Tu contraseña fue actualizada!",
  passwordMismatch: "Las contraseñas no coinciden.",
  setFirstPasswordTitle: "Creá tu contraseña",
  setFirstPasswordSubtitle:
    "Establecé una contraseña para asegurar tu cuenta antes de continuar.",
  setFirstPasswordButton: "Guardar contraseña y continuar",
  magicLinkSent: "¡Enlace de acceso enviado!",
  failedToLoadUser: "Error al cargar el usuario",
  failedSendMagicLink: "Error al enviar el enlace de acceso",
  userDeletedSuccess: "Usuario eliminado",
  failedDeleteUser: "Error al eliminar el usuario",
  verifyingLink: "Verificando tu enlace de acceso…",
  accessGranted: "¡Acceso concedido!",
  redirectToSetPassword: "Redirigiendo para establecer tu contraseña…",
  linkInvalid: "Enlace inválido",
  backToLogin: "Volver al inicio de sesión",
  editUsernameTitle: "Editar usuario",
  festivalDateFrom: "Desde",
  festivalDateTo: "Hasta",
  sectionFestivalDates: "Fechas del festival",
  adminEmptyListTitle: "Nada por aquí",
  adminEmptyListMsg: "No hay elementos que coincidan con el filtro actual.",
  total: "Total",
  bulkImport: "Importación masiva",
  bulkImportTitle: "Pegar array JSON",
  bulkImportSubtitle: "Pegá un array de objetos de eventos. Máximo 50 items.",
  bulkValidateBtn: "Validar JSON",
  bulkImportBtn: "Importar eventos",
  bulkResetBtn: "Reiniciar",
  bulkErrorTitle: "Error de JSON:",
  bulkSummaryTitle: "Resumen de validación",
  bulkDetected: "detectados",
  bulkValid: "válidos",
  bulkWithErrors: "con errores",
  bulkReadyToImport: "Listos para importar:",
  bulkFixErrors: "Corregí estos errores antes de importar:",
  bulkAllValid:
    'Todos los eventos son válidos. Hacé clic en "Importar eventos" para continuar.',
  bulkImportResultTitle: "Resultado de importación",
  bulkImportedOk: "evento(s) importado(s) como pendiente.",
  bulkImportedFailed: "fallaron:",
  bulkFormatGuide: "Formato esperado",
  bulkFormatDesc: "Un array de objetos con estos campos:",
  bulkValidCategories: "Categorías válidas:",
  bulkOptionalFields: "Campos opcionales:",
  bulkCheckingDuplicates: "Verificando…",
  bulkDuplicateWarningTitle:
    "Posibles duplicados encontrados — revisá antes de importar:",
  bulkDuplicateExists: "Ya existe:",
  bulkAllValidWithWarnings:
    "El JSON es válido pero algunos eventos podrían ya existir. Revisá los warnings antes de importar.",
  bulkDuplicateConfirmTitle: "Posibles duplicados detectados",
  bulkDuplicateConfirmBody:
    "Algunos eventos podrían ya existir en la base de datos. ¿Querés importarlos de todas formas?",
  bulkDuplicateConfirmImport: "Importar de todas formas",

  // Web feedback / reporte de usuario
  webFeedback: "Contáctanos",
  webFeedbackTitle: "Reporte / Feedback",
  webFeedbackDesc:
    "Usá este formulario para reportar errores o sugerir mejoras a Bailo.app. El equipo revisará tu mensaje y te responderá por la campanita de notificaciones.",
  webFeedbackMessage: "Tu mensaje",
  webFeedbackPlaceholder: "Describí el problema o la mejora en detalle…",
  webFeedbackAttachImage: "Adjuntar imagen",
  webFeedbackChooseImage: "Elegir imagen",
  webFeedbackRequired: "Por favor escribí un mensaje antes de enviar.",
  webFeedbackConfirm1Title: "¿Enviar reporte?",
  webFeedbackConfirm1Body:
    "Tu reporte llegará directamente al equipo de Bailo.app. ¿Querés continuar?",
  webFeedbackConfirm2Title: "¿Estás seguro/a?",
  webFeedbackConfirm2Body:
    "Esto enviará tu reporte. Lo revisaremos y te avisaremos por la campanita.",
  webFeedbackSendFinal: "Enviar reporte",
  webFeedbackSent: "¡Reporte enviado con éxito! Lo revisaremos pronto.",

  // Admin web feedback
  adminWebFeedback: "Feedback de la App",
  webFeedbackInProgress: "En progreso",
  webFeedbackUpdateStatus: "Actualizar estado",
  webFeedbackAdminNote: "Nota para el usuario",
  webFeedbackAdminNotePlaceholder: "Nota breve visible para el usuario…",
  webFeedbackViewImage: "Ver imagen",
  webFeedbackDeleteConfirm:
    "¿Estás seguro/a de que querés eliminar este reporte?",
  webFeedbackCleanupResolved: "Eliminar resueltos",
  webFeedbackCleanupTitle: "¿Eliminar todos los resueltos?",
  webFeedbackCleanupBody:
    "Esto eliminará permanentemente los {n} reporte(s) resueltos, incluyendo las imágenes adjuntas. Esta acción no se puede deshacer.",
  webFeedbackStatus_pending: "Pendiente",
  "webFeedbackStatus_in-progress": "En progreso",
  webFeedbackStatus_resolved: "Resuelto",
  webFeedbackStatus_rejected: "Rechazado",

  // Campanita de notificaciones
  notifications: "Notificaciones",
  notificationsEmpty: "Sin notificaciones aún",
  notifMarkAllRead: "Marcar todas como leídas",

  // Misc
  optional: "opcional",
  save: "Guardar",
  update: "Actualizar",
  delete: "Eliminar",
  deleteConfirm: "¿Eliminar?",
  resolved: "Resuelto",
  noResults: "No se encontraron resultados.",
};

export default spa;
